// extracted by mini-css-extract-plugin
export default {"scannerItem":"ScannerItem_scannerItem__nLu1z"};